import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Disclaimer } from "./components/Disclaimer";
import ScrollToTop from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { PracticeAreas } from "./pages/PracticeAreas";
import { Solutions } from "./pages/Solutions";
import { ThoughtLeadership } from "./pages/ThoughtLeadership";
import { Contact } from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <Disclaimer />
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/practice-areas" element={<PracticeAreas />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/thought-leadership" element={<ThoughtLeadership />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
